"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledListboxOption = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ListboxOptionMixin = require("../../mixins/components/ListboxOptionMixin");
var StyledListboxOption = /*#__PURE__*/_styledComponents.default.li.withConfig({
  displayName: "StyledListboxOption",
  componentId: "c11n-8-107-0__sc-7hr6e0-0"
})(["", ""], _ListboxOptionMixin.ListboxOptionMixin);
exports.StyledListboxOption = StyledListboxOption;